module.exports = __webpack_public_path__ + "img/money99.8cb10141.png";